<p-dialog
	styleClass="update-dialog"
	[header]="'Application Update Available'"
	[modal]="true"
	[closable]="false"
	[draggable]="false"
	[resizable]="false"
	[visible]="visible()"
	[style]="{ width: '700px' }"
>
	<p-fieldset legend="New Version Available" styleClass="mb-4">
		<div class="flex items-center justify-between rounded border border-gray-200 bg-gray-50 px-4 py-3">
			<div class="flex items-center space-x-3">
				<i class="pi pi-info-circle text-lg text-blue-500"></i>
				<div>
					<span class="text-xs font-medium text-gray-600">Current Version:</span>
					<div class="text-sm font-semibold text-gray-900">{{ currentVersion }}</div>
					<div class="mt-1 text-xs text-gray-500">
						<span>{{ currentBuildInfo.date }}</span> •
						<span class="font-mono">{{ currentBuildInfo.hash }}</span>
					</div>
					<div class="mt-1 font-mono text-xs text-gray-400">build: {{ currentBuildInfo.build }}</div>
				</div>
			</div>
			<div class="flex items-center space-x-2">
				<i class="pi pi-arrow-right text-gray-400"></i>
			</div>
			<div class="flex items-center space-x-3">
				<div class="text-right">
					<span class="text-xs font-medium text-gray-600">Latest Version:</span>
					<div class="text-sm font-semibold text-blue-600">{{ latestVersion }}</div>
					<div class="mt-1 text-xs text-gray-500">
						<span>{{ latestBuildInfo.date }}</span> •
						<span class="font-mono">{{ latestBuildInfo.hash }}</span>
					</div>
					<div class="mt-1 font-mono text-xs text-gray-400">build: {{ latestBuildInfo.build }}</div>
				</div>
			</div>
		</div>
	</p-fieldset>

	@if (releaseNotes.length > 0) {
		<p-fieldset legend="What's New" styleClass="mb-4">
			<div class="space-y-2">
				@for (note of releaseNotes; track $index) {
					<div class="flex items-start gap-3 rounded border border-gray-200 bg-gray-50 px-3 py-2">
						<i class="pi pi-check-circle mt-0.5 text-sm text-green-500"></i>
						<span class="text-sm text-gray-700">{{ note }}</span>
					</div>
				}
			</div>
		</p-fieldset>
	}

	<p-fieldset legend="Important Notice" styleClass="mb-4">
		<div class="flex items-start gap-3 rounded border border-yellow-200 bg-yellow-50 px-4 py-3">
			<i class="pi pi-exclamation-triangle mt-0.5 text-lg text-yellow-600"></i>
			<div class="text-sm text-yellow-800">
				<p class="font-medium">Unsaved Changes Warning</p>
				<p class="mt-1">
					Clicking "Update Now" will reload the application. Make sure to save any unsaved work before proceeding.
				</p>
			</div>
		</div>
	</p-fieldset>

	<ng-template #footer>
		<div class="flex justify-end gap-3">
			<p-button
				label="Ask Me Later"
				icon="pi pi-clock"
				severity="secondary"
				[outlined]="true"
				[disabled]="isProcessing()"
				(onClick)="onAskLater()"
			/>
			<p-button label="Update Now" icon="pi pi-refresh" severity="info" [loading]="isProcessing()" (onClick)="onUpdateNow()" />
		</div>
	</ng-template>
</p-dialog>
